import { useQuery } from '@tanstack/react-query';
import { FC } from 'react';
import { LocationDetailsFleetButton } from 'src/locations/LocationDetailsFleetButton';
import { rsimProductDetailsQueries } from 'src/rSimInventory/Details/utils/rsimProductDetailsQueries';
import { fetchRSim } from 'src/rSimInventory/RSimApi/rSimApi';
import { fetchSimInventoryEntry } from 'src/simInventory/SimInventoryApi/simInventoryApi';

type RSimLocationDetailsFleetButtonProps = {
  euicc: string;
};

export const RSimLocationDetailsFleetButton: FC<RSimLocationDetailsFleetButtonProps> = (props) => {
  const { euicc } = props;

  const { data, status } = useQuery({
    queryKey: rsimProductDetailsQueries.location({ euicc }),
    queryFn: async ({ signal }) => {
      const rsimsDetails = await fetchRSim(euicc, signal);
      const rsimDetails = rsimsDetails.items[0];

      const profiles = await Promise.all(
        [rsimDetails.primaryIccid, rsimDetails.secondaryIccid].map((iccid) =>
          fetchSimInventoryEntry(iccid, undefined, signal),
        ),
      );

      return {
        rsimDetails,
        profiles,
      };
    },
    meta: {
      isLocationsDetails: true,
    },
  });

  if (status === 'pending') {
    return <LocationDetailsFleetButton loading={true} />;
  }

  if (status === 'success' && data.profiles[0].accountRef) {
    return <LocationDetailsFleetButton loading={false} accountId={data.profiles[0].accountRef} />;
  }

  return null;
};
